
// Getters (GET*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const GET_SELECTED_USER_TYPE = 'GET_SELECTED_USER_TYPE';
export const GET_REGISTER_FORM_VISIBILITY = 'GET_REGISTER_FORM_VISIBILITY';
export const GET_USER_TYPE_LIST = 'GET_USER_TYPE_LIST';


// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const FETCH_USER_TYPE_LIST = 'FETCH_USER_TYPE_LIST';
export const CREATE_USER_TYPE_LIST = 'CREATE_USER_TYPE_LIST';
export const UPDATE_USER_TYPE_LIST = 'UPDATE_USER_TYPE_LIST';
export const CREATE_USER_TYPE = 'CREATE_USER_TYPE';
export const UPDATE_REGISTER_FORM_VISIBILITY = 'UPDATE_REGISTER_FORM_VISIBILITY';
export const UPDATE_USER_TYPE = 'UPDATE_USER_TYPE';


// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const SET_SELECTED_USER_TYPE = 'SET_SELECTED_USER_TYPE';
export const SET_USER_TYPE_LIST = 'SET_USER_TYPE_LIST';
export const ADD_USER_TYPE_TO_LIST = 'ADD_USER_TYPE_TO_LIST';
export const SET_USER_FORM_VISIBILITY = 'SET_USER_FORM_VISIBILITY';
